import * as React from 'react'
import styled from 'styled-components'
import {Colors} from '../../../styledComponents/Constants'
import {Button} from '@mui/material'
import {MenuBook} from '@mui/icons-material'
import {FullWidthColumnFlexContainer} from '../../../styledComponents/FlexComponents'

const GUEST_HEADER_HEIGHT = 60

const LogoText = styled.div`
  font-size: 16px;
  font-weight: bold;
  white-space: nowrap;
  width: 140px;
  text-align: left;
`

const LogoSubText = styled.div`
  padding-left: 56px;
  font-size: 12px;
  line-height: 12px;
  white-space: nowrap;
`

export const GuestHeaderLogo = () => <>
    <FullWidthColumnFlexContainer>
        <LogoText>
            素敵ネット
        </LogoText>
        <LogoSubText>
            入退去手続き用
        </LogoSubText>
    </FullWidthColumnFlexContainer>
</>

const ManualButton = styled(Button)`
  &.MuiButton-root {
    height: ${GUEST_HEADER_HEIGHT}px;
    padding: 0 8px;
    border-radius: 0;
      color: ${Colors.Surface};
      background-color: ${Colors.GuestPrimary};
      @media(hover: hover) {
        :hover {
          background-color: ${Colors.GuestPrimary};
        }
      }
      @media(hover: none) {
        :hover {
          background-color: ${Colors.GuestPrimary};
        }
  }
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`

const ManualButtonText = styled.span`
  font-size: 12px;
  white-space: nowrap;
`

export const GuestManualButton = (props: {
    onClick: () => void,
}) => <>
    <ManualButton
        onClick={props.onClick}
        disableRipple={true}
    >
        <MenuBook fontSize={'large'}/>
        <ManualButtonText>マニュアル</ManualButtonText>
    </ManualButton>
</>
